import {ShapeCommand} from '../../commands.template';
import * as _ from 'lodash';

export class FlowlineChangeInteractionDescriptionCommand extends ShapeCommand {
  services: any;
  reverseData: any;

  constructor(data) {
    super(data);
  }

  public prepareData() {
    return this;
  }

  public execute() {
    super.execute();
    const interaction = _.find(this.services.jsonHandlerSvc.get().interactions, ia => {
      return Number(ia.flowlineMxKey) === Number(this.object.flowlineMxKey);
    });

    this.reverseData = {description: interaction.description || ''};

    const action = {
      changeInteraction: {
        flowlineMxKey: Number(this.object.flowlineMxKey),
        description: this.object.description
      }
    };

    this.services.diagramUpdateSvc.update(action);
  }

  public reverse() {
    super.reverse();

    const action = {
      changeInteraction: {
        flowlineMxKey: Number(this.object.flowlineMxKey),
        description: this.reverseData.description
      }
    };

    this.services.diagramUpdateSvc.update(action);
  }
}
